import React, { useState } from "react";
import { Link } from "react-router-dom";
import CallIcon from "@mui/icons-material/Call";
import CDCLogo from "../../assets/final-images/Header/cdc_new_logo_1.png";
import MobileMenu from "./MobileMenu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DropdownImage from "../../assets/final-images/homepage/aquilionprimeSP_485_nologo.jpg";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

//DROPDOWN ICONS
import AutoIcon from "../../assets/icons/menu-icons/AutoPersonal Injury Imagin-01.png";
import BodyIcon from "../../assets/icons/menu-icons/Body Imaging-01.png";
import CardiacIcon from "../../assets/icons/menu-icons/Cardiac Imaging-01.png";
import MskIcon from "../../assets/icons/menu-icons/Musculoskeletal Imaging-01.png";
import NeuroIcon from "../../assets/icons/menu-icons/Neurological Imaging-01.png";
import OncologyIcon from "../../assets/icons/menu-icons/Oncology Imaging-01.png";
import VascularIcon from "../../assets/icons/menu-icons/Vascular Imaging-01.png";
import WomenIcon from "../../assets/icons/menu-icons/Women's Imaging-01.png";
import MammographyIcon from "../../assets/icons/menu-icons/2D-3D Mammography-01.png";
import NuclearIcon from "../../assets/icons/menu-icons/Cardiac - Body Nuclear Medicine-01.png";
import XrayIcon from "../../assets/icons/menu-icons/Digital X-Ray-01.png";
import EchoIcon from "../../assets/icons/menu-icons/Echocardiography-01.png";
import UltrasoundIcon from "../../assets/icons/menu-icons/General Vascular Ultrasound-01.png";
import MRIIcon from "../../assets/icons/menu-icons/High-Field - Open MRI-01.png";
import CtIcon from "../../assets/icons/menu-icons/Low Dose 160-Slice Open CT-01.png";
import DexaIcon from "../../assets/icons/menu-icons/Osteoporosis DEXA Scan-01.png";
import PetCtIcon from "../../assets/icons/menu-icons/PET - CT-01.png";
import ProstateIcon from "../../assets/icons/menu-icons/Prostate-Cancer-01.png";
import { HashLink } from "react-router-hash-link";

/* ================= LOGIN LINKS ================= */
const loginButtons = [
  {
    label: "Patient Login",
    url: "https://citrusfl.abbadox.com/patientportal/login",
  },
  {
    label: "Provider Login",
    url: "https://urldefense.proofpoint.com/v2/url?u=http-3A__www.abbadoxcareflow.com_&d=DwMF-g&c=euGZstcaTDllvimEN8b7jXrwqOf-v5A_CdpgnVfiiMM&r=YVOHKV0ooKH3u_8PMI-eeHLiArirMnx9nsjd9-WiR9xM4lyq7ur3jyAB6W7z4Zmo&m=x2SSMh8aAnzMxWYil6Wj-KzAqV0oRiNO0ZkByv6rll29F05I8J0Zmxh-RXWAtgXa&s=ez52n8cfnvSQa08OC11YLUHg0MTxZfA41JBnV2RJPyk&e=2.718",
  },
  { label: "Legal Login", url: "https://prod.myclearpath.com/login" },
];

/* ================= SERVICES MENU ================= */
const servicesMegaMenu = {
  subspecialties: [
    {
      label: "Auto/Personal Injury Imaging",
      icon: AutoIcon,
      link: "/personal-injury",
    },
    {
      label: "Body Imaging",
      icon: BodyIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Cardiothoracic Imaging",
      icon: CardiacIcon,
      link: "/cardiac-imaging",
    },
    {
      label: "Musculoskeletal Imaging",
      icon: MskIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Neurological Imaging",
      icon: NeuroIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Oncology Imaging",
      icon: OncologyIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Prostate Imaging",
      icon: ProstateIcon,
      link: "/prostate-on-mri",
    },
    {
      label: "Vascular Imaging",
      icon: VascularIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Women’s Imaging",
      icon: WomenIcon,
      link: "/womens-imaging-center",
    },
  ],

  tests: [
    {
      label: "2D/3D Mammography",
      icon: MammographyIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Cardiac/General Nuclear Medicine",
      icon: NuclearIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Digital X-Ray",
      icon: XrayIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Echocardiography",
      icon: EchoIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "General/Vascular Ultrasound",
      icon: UltrasoundIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "High-Field/Open MRI",
      icon: MRIIcon,
      link: "/open-mri-and-imaging",
    },
    {
      label: "Low Dose 160-Slice Open CT",
      icon: CtIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Osteoporosis DEXA Scan",
      icon: DexaIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "PET/CT",
      icon: PetCtIcon,
      link: "/pet-scan-imaging",
    },
  ],
};

export default function Headerbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  // ✅ Alphabetical sorting
  const sortedSubspecialties = [...servicesMegaMenu.subspecialties].sort(
    (a, b) => a.label.localeCompare(b.label),
  );

  const sortedTests = [...servicesMegaMenu.tests].sort((a, b) =>
    a.label.localeCompare(b.label),
  );
  return (
    <div className="p-6 bg-transparent">
      <header className="fixed top-5 left-0 right-0 z-50 px-6">
        {/* ================= MOBILE HEADER ================= */}
        <div
          className="flex 2xl:hidden justify-between items-center
                        border border-[#2b2b2b] font-robout rounded-[16px]
                        bg-[#0f0f0f] px-4"
        >
          <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>
            <img src={CDCLogo} alt="CDC" className="w-20" />
          </Link>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-white text-2xl"
          >
            {isMobileMenuOpen ? "✕" : "☰"}
          </button>
        </div>

        {/* ================= DESKTOP HEADER ================= */}
        <div className="hidden 2xl:flex justify-between">
          {/* LEFT BLOCK */}
          <div
            className="flex items-center gap-5
                          border border-[#2b2b2b] rounded-[16px]
                          bg-[#0f0f0f] font-robout  px-5"
          >
            <Link to="/">
              <img src={CDCLogo} alt="CDC" className="w-20" />
            </Link>

            <div className="border-l border-[#2b2b2b] h-6" />

            <Link
              to="tel:3527959200"
              className="flex items-center gap-2 text-white font-normal text-[15px]"
            >
              <CallIcon sx={{ color: "#bf9c5e" }} />
              <span>(352) 795-9200</span>
            </Link>
          </div>

          {/* RIGHT BLOCK (IMPORTANT: relative) */}
          <div
            className="relative flex items-center
                          border border-[#2b2b2b] rounded-[16px]
                          bg-[#0f0f0f] font-robout  px-5"
          >
            <ul className="flex items-center gap-2 text-[#7a7a7a] font-bold text-[15px] font-robout">
              <li>
                <Link
                  className="3xl:px-3 px-1 py-2 rounded-[8px] hover:bg-[#1a1a1a] hover:text-[#f5f5f5]"
                  to="/"
                >
                  Home
                </Link>
              </li>

              <li
                className="group relative"
                onMouseEnter={() => setIsAboutOpen(true)}
                onMouseLeave={() => setIsAboutOpen(false)}
              >
                <Link
                  to="/about-us"
                  className="3xl:px-3 px-1 py-2 rounded-[8px] font-robout text-[15px]
               flex items-center gap-1
               hover:bg-[#1a1a1a] hover:text-[#f5f5f5]"
                >
                  About
                  <span className="block group-hover:hidden">
                    <KeyboardArrowDownIcon sx={{ fontSize: 15 }} />
                  </span>
                  <span className="hidden group-hover:block">
                    <KeyboardArrowUpIcon sx={{ fontSize: 15 }} />
                  </span>
                </Link>

                {/* ABOUT DROPDOWN */}
                <div
                  className={`absolute top-full left-1/2 -translate-x-1/2 mt-4 w-[200px]
    transition-all duration-200
    ${isAboutOpen ? "opacity-100 visible" : "opacity-0 invisible"}`}
                >
                  <div
                    className="bg-[#0f0f0f] border border-[#2b2b2b]
                 rounded-[14px] py-3"
                  >
                    <ul className="text-[15px] font-robout text-[#9a9a9a] flex flex-col justify-center items-center text-center">
                      <li>
                        <HashLink
                          to="/about-us#history"
                          onClick={() => setIsAboutOpen(false)}
                          className="block px-5 py-2 hover:text-white "
                        >
                          History
                        </HashLink>
                      </li>
                      <li>
                        <HashLink
                          to="/about-us#leadership"
                          onClick={() => setIsAboutOpen(false)}
                          className="block px-5 py-2 hover:text-white "
                        >
                          Leadership
                        </HashLink>
                      </li>
                      <li>
                        <HashLink
                          to="/about-us#featured-services"
                          onClick={() => setIsAboutOpen(false)}
                          className="block px-5 py-2 hover:text-white "
                        >
                          Featured Services
                        </HashLink>
                      </li>
                      <li>
                        <HashLink
                          to="/about-us#accreditations"
                          onClick={() => setIsAboutOpen(false)}
                          className="block px-5 py-2 hover:text-white "
                        >
                          Accreditations
                        </HashLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>

              {/* ================= SERVICES DROPDOWN ================= */}
              <li
                className="group"
                onMouseEnter={() => setIsServicesOpen(true)}
                onMouseLeave={() => setIsServicesOpen(false)}
              >
                <Link
                  to="/diagnostic-imaging-services"
                  className="3xl:px-3 px-1 py-2 font-robout rounded-[8px]
               flex items-center
               hover:bg-[#1a1a1a] hover:text-[#f5f5f5]"
                >
                  <span className="flex items-center gap-1 pointer-events-none">
                    Services
                    {/* DOWN ARROW (default) */}
                    <span className="block group-hover:hidden">
                      <KeyboardArrowDownIcon sx={{ fontSize: "15px" }} />
                    </span>
                    {/* UP ARROW (stays until leaving dropdown) */}
                    <span className="hidden group-hover:block">
                      <KeyboardArrowUpIcon sx={{ fontSize: "15px" }} />
                    </span>
                  </span>
                </Link>

                {/* DROPDOWN (WIDTH = RIGHT BLOCK) */}
                <div
                  className={`absolute right-0 top-full mt-4 w-full
  transition-all duration-200
  ${isServicesOpen ? "opacity-100 visible" : "opacity-0 invisible"}`}
                >
                  <div
                    className="bg-[#0f0f0f] hover:text-[#f5f5f5] border border-[#2b2b2b]
                                  rounded-[20px]  py-5"
                  >
                    <div className="grid grid-cols-3 divide-x divide-[#2b2b2b]">
                      {/* COLUMN 1 */}
                      <div className="px-10 py-5">
                        <h4 className="text-white font-bold mb-4">
                          Imaging Subspecialties
                        </h4>
                        <ul className="space-y-3 text-[15px] font-robout text-[#9a9a9a]">
                          {sortedSubspecialties.map((item) => (
                            <li key={item.label}>
                              <Link
                                to={item.link}
                                onClick={() => setIsServicesOpen(false)}
                                className="flex items-center gap-3 hover:text-white transition-colors"
                              >
                                <img
                                  src={item.icon}
                                  alt=""
                                  className="object-contain opacity-80"
                                />
                                <span>{item.label}</span>
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* COLUMN 2 */}
                      <div className="px-10 py-5">
                        <h4 className="text-white font-bold mb-4">
                          Imaging Tests
                        </h4>
                        <ul className="space-y-3 text-[15px] font-robout text-[#9a9a9a]">
                          {sortedTests.map((item) => (
                            <li key={item.label}>
                              <Link
                                to={item.link}
                                onClick={() => setIsServicesOpen(false)}
                                className="flex items-center gap-3 hover:text-white transition-colors"
                              >
                                <img
                                  src={item.icon}
                                  alt=""
                                  className="w-auto h-auto object-contain opacity-80"
                                />
                                <span>{item.label}</span>
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                      {/* COLUMN 3 */}
                      <div className="px-10 py-5 flex flex-col gap-4">
                        <div className="rounded-[14px] w-full overflow-hidden">
                          <img
                            src={DropdownImage}
                            alt=""
                            className="w-full h-auto object-cover rounded-[14px]"
                          />
                        </div>

                        <Link
                          to="/diagnostic-imaging-services"
                          className="flex items-center gap-2 pt-5
             text-[15px] font-bold text-[#bf9c5e]
             hover:text-white transition-colors"
                        >
                          <span className="leading-none">
                            View all services
                          </span>
                          <ArrowRightAltIcon sx={{ fontSize: 20 }} />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li>
                <Link
                  className="3xl:px-3 px-1 py-2 rounded-[8px] font-robout text-[15px] hover:bg-[#1a1a1a] hover:text-[#f5f5f5]"
                  to="/patient-portal"
                >
                  Patients
                </Link>
              </li>

              <li>
                <Link
                  className="3xl:px-3 px-1 py-2 rounded-[8px] font-robout text-[15px] hover:bg-[#1a1a1a] hover:text-[#f5f5f5]"
                  to="/healthcare-providers"
                >
                  Providers
                </Link>
              </li>

              <li
                className="group relative"
                onMouseEnter={() => setIsResourcesOpen(true)}
                onMouseLeave={() => setIsResourcesOpen(false)}
              >
                <HashLink
                  to="/resources"
                  className="3xl:px-3 px-1 py-2 rounded-[8px] font-robout text-[15px]
               flex items-center gap-1
               hover:bg-[#1a1a1a] hover:text-[#f5f5f5]"
                >
                  Resources
                  <span className="block group-hover:hidden">
                    <KeyboardArrowDownIcon sx={{ fontSize: 15 }} />
                  </span>
                  <span className="hidden group-hover:block">
                    <KeyboardArrowUpIcon sx={{ fontSize: 15 }} />
                  </span>
                </HashLink>

                {/* RESOURCES DROPDOWN */}
                <div
                  className={`absolute top-full left-1/2 -translate-x-1/2 mt-4 w-[200px]
    transition-all duration-200
    ${isResourcesOpen ? "opacity-100 visible" : "opacity-0 invisible"}`}
                >
                  <div
                    className="bg-[#0f0f0f] border border-[#2b2b2b]
                 rounded-[14px] py-3"
                  >
                    <ul className="text-[15px] font-robout text-[#9a9a9a] flex flex-col justify-center items-center text-center">
                      <li>
                        <HashLink
                          to="/resources"
                          onClick={() => setIsResourcesOpen(false)}
                          className="block px-5 py-2 hover:text-white "
                        >
                          Insurance & Billing
                        </HashLink>
                      </li>
                      <li>
                        <HashLink
                          to="/resources#medical-records"
                          onClick={() => setIsResourcesOpen(false)}
                          className="block px-5 py-2 hover:text-white "
                        >
                          Medical Records
                        </HashLink>
                      </li>

                      <li>
                        <HashLink
                          to="/advanced-ai-medical-imaging"
                          onClick={() => setIsResourcesOpen(false)}
                          className="block px-5 py-2 hover:text-white "
                        >
                          Advanced Technology & AI
                        </HashLink>
                      </li>
                      <li>
                        <Link
                          to="/faqs"
                          onClick={() => setIsResourcesOpen(false)}
                          className="block px-5 py-2 hover:text-white "
                        >
                          FAQs
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>

              {/* LOGIN BUTTONS */}
              {loginButtons.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2 rounded-[8px]
                               bg-[#f5f5f5] text-black font-bold
                               hover:bg-[#707070] text-[15px]"
                  >
                    {item.label}
                  </a>
                </li>
              ))}

              <li className="group">
                <Link
                  to="/contact-us"
                  className="px-4 py-2 rounded-[8px]
               bg-[#2c0303] font-robout text-white font-bold
               hover:bg-[#707070]
               flex items-center gap-1"
                >
                  Contact
                  <span className="block group-hover:hidden">
                    <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />
                  </span>
                  <span className="hidden group-hover:block">
                    <KeyboardArrowUpIcon sx={{ fontSize: 16 }} />
                  </span>
                </Link>

                {/* CONTACT DROPDOWN */}
                <div
                  className="absolute right-0 top-full mt-4 w-full
               opacity-0 invisible
               group-hover:opacity-100 group-hover:visible
               transition-all duration-200"
                >
                  <div
                    className="bg-[#0f0f0f] hover:text-[#f5f5f5] border border-[#2b2b2b]
                 rounded-[20px] px-10 py-6"
                  >
                    <div className="grid grid-cols-4 divide-x divide-[#2b2b2b]">
                      <div>
                        <h4 className="text-white font-bold mb-2">Office</h4>
                        <Link
                          to="tel:3527959200"
                          className="text-[#9a9a9a] hover:text-[#f5f5f5] text-[15px]"
                        >
                          (352) 795-9200
                        </Link>
                      </div>

                      <div className="px-10">
                        <h4 className="text-white font-bold mb-2">Billing</h4>
                        <Link
                          to="tel:3524508062"
                          className="text-[#9a9a9a] hover:text-[#f5f5f5] text-[15px]"
                        >
                          (352) 450-8062
                        </Link>
                      </div>
                      <div className="px-10">
                        <h4 className="text-white font-bold mb-2">Fax</h4>

                        <a
                          href="fax:3527956460"
                          className="text-[#9a9a9a] hover:text-[#f5f5f5] text-[15px] cursor-pointer"
                          onClick={(e) => {
                            e.preventDefault();

                            const faxNumber = "352-795-6460";

                            // 1️⃣ Try opening fax
                            window.location.href = "fax:3527956460";

                            // 2️⃣ Always copy (guaranteed)
                            navigator.clipboard.writeText(faxNumber);
                          }}
                        >
                          (352) 795-6460
                        </a>
                      </div>

                      <div className="pl-10">
                        <h4 className="text-white font-bold mb-2">Visit</h4>
                        <Link
                          to="https://maps.app.goo.gl/MQ5H5FsCB4nBt8dy7"
                          target="_blank"
                          className="text-[#9a9a9a] hover:text-[#f5f5f5] text-[15px] leading-relaxed"
                        >
                          922 North Citrus Avenue,{" "}
                          <span className="text-nowrap">Crystal River</span>,
                          Florida 34428
                        </Link>

                        <Link
                          to="/contact-us"
                          className="flex items-center gap-2 mt-3
                       text-[15px] font-bold text-[#bf9c5e]
                       hover:text-white transition-colors"
                        >
                          <span className="leading-none">Schedule Now</span>
                          <ArrowRightAltIcon sx={{ fontSize: 20 }} />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </header>

      {/* MOBILE MENU */}
      {isMobileMenuOpen && (
        <MobileMenu onClose={() => setIsMobileMenuOpen(false)} />
      )}
    </div>
  );
}
